import {
    SIGNUP_USER,
    SIGNIN_USER,
    SIGNOUT_USER,
    SIGNIN_USER_SUCCESS,
    SIGNIN_USER_FAILED,
    // SIGNOUT_USER_SUCCESS,
    SIGNUP_USER_SUCCESS,
    SIGNUP_USER_FAILED,
    HIDE_MESSAGE,
    BACK_TO_LOGIN,
    INIT_URL,
    RESET_STATUS,
    OTP_USER_SUCCESS,
    OTP_USER_FAILED,
    HIDE_MODAL,
    FILL_EMPTY
} from "constants/ActionTypes";
import {
    CHANGE_PASSWORD, 
    CHANGE_PASSWORD_FAILED,
    CHANGE_PASSWORD_SUCCESS,
    FORGOT_PASSWORD,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILED
} from "../../constants/ActionTypes";

let localAuth = {
    authToken : localStorage.getItem('a'),
    deviceId : localStorage.getItem('d'),
    userId : localStorage.getItem('u'),
    merchantId : localStorage.getItem('mt'),
    firstName : localStorage.getItem('f'),
    lastName : localStorage.getItem('l'),
    phoneNumber : localStorage.getItem('p'),
    loginName : localStorage.getItem('e'),
    merchantName : localStorage.getItem('mtn'),
    userPic : localStorage.getItem("upic")
}

const INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessage: false,
    initURL: '',
    authUser: localAuth,
    updateSuccess: false,
    updateFailed: false,
    updateResponse: [],
    showOtp : false
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SIGNUP_USER: {
            return {
                ...state,
                loader: true,
                showMessage: false
            }
        }

        case SIGNIN_USER: {
            return {
                ...state,
                loader: true,
                showMessage: false
            }
        }

        case SIGNOUT_USER: {
            localStorage.clear();
            localStorage.removeItem("memberId");
            localStorage.removeItem("u");
            localStorage.removeItem("f");
            localStorage.removeItem("l");
            localStorage.removeItem("p");
            localStorage.removeItem("e");
            localStorage.removeItem("mt");
            localStorage.removeItem("a");
            localStorage.removeItem("d");
            localStorage.removeItem("mtn");
            localStorage.removeItem("upic");
            return {
                ...state,
                authUser: localAuth,
                initURL: '/signin',
                loader: false
            }
        }

        case BACK_TO_LOGIN:{
            localStorage.clear();
            localStorage.removeItem("memberId");
            localStorage.removeItem("u");
            localStorage.removeItem("f");
            localStorage.removeItem("l");
            localStorage.removeItem("p");
            localStorage.removeItem("e");
            localStorage.removeItem("mt");
            localStorage.removeItem("a");
            localStorage.removeItem("d");
            localStorage.removeItem("mtn");
            localStorage.removeItem("upic");
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                authUser: localAuth,
                loader: false,
                initURL: '/signin'
            }
        }

        case CHANGE_PASSWORD: {
            return {
                ...state,
                loader: true,
                showMessage: false,
                updateSuccess: false,
                updateFailed: false
            }
        }

        case FORGOT_PASSWORD: {
            return {
                ...state,
                loader: true,
                showMessage: false,
                updateSuccess: false,
                updateFailed: false
            }
        }
        
        case RESET_STATUS : {
            return {
                ...state,
                updateSuccess: false,
                updateFailed : false,
            }
        }

        // Response
        case SIGNUP_USER_SUCCESS: {
            this.props.history.push('/');
            return {
                ...state,
                loader: false,
                authUser: action.payload
            }
        }

        case SIGNUP_USER_FAILED: {
            return {
                ...state,
                loader: false,
                alertMessage: action.payload,
                showMessage: true
            }
        }
        
        case SIGNIN_USER_SUCCESS: {
            return {
                ...state,
                loader: false,
                authUser: action.payload,
                initURL: '/',
                showOtp : false
            }
        }

        case SIGNIN_USER_FAILED: {
            return {
                ...state,
                loader: false,
                alertMessage: action.payload,
                showMessage: true,
                showOtp : false
            }
        }

        case OTP_USER_SUCCESS: {
            return {
                ...state,
                authUser: action.payload,
                showOtp : true,
                loader: false,
            }
        }

        case OTP_USER_FAILED: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                showOtp : true,
                loader: false,
            }
        }

        case HIDE_MODAL: {
            return {
                ...state,
                loader: false,
                showMessage: false,
                showOtp : false,
                authUser: null,
            }
        }

        case FILL_EMPTY: {
            return {
                ...state,
                showMessage: true,
                alertMessage : "Please fill the OTP field",
            }
        }

        // case SIGNOUT_USER_SUCCESS: {
        //     return {
        //         ...state,
        //         authUser: null,
        //         initURL: '/',
        //         loader: false
        //     }
        // }

        case HIDE_MESSAGE: {
            return {
                ...state,
                alertMessage: '',
                showMessage: false,
                loader: false
            }
        }


        case INIT_URL: {
            return {
                ...state,
                initURL: action.payload
            }
        }

        case FORGOT_PASSWORD_SUCCESS: {
            return {
                ...state,
                loader: false,
                updateSuccess : true,
                updateFailed: false,
                showMessage: false
            }
        }

        case FORGOT_PASSWORD_FAILED: {
            return {
                ...state,
                loader: false,
                alertMessage : action.payload,
                updateSuccess : false,
                updateFailed: true,
                showMessage: false
            }
        }

        case CHANGE_PASSWORD_SUCCESS: {
            return {
                ...state,
                loader: false,
                updateSuccess : true,
                updateFailed: false,
                showMessage: false
            }
        }

        case CHANGE_PASSWORD_FAILED: {
            return {
                ...state,
                loader: false,
                alertMessage : action.payload,
                updateSuccess : false,
                updateFailed: true,
                showMessage: false
            }
        }


        default:
            return state;
    }
}
